import React from "react";

export const RightArrow = ({ width = 18, height = 14 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M.675 7.696h15.021l-4.972 5.118a.71.71 0 0 0 0 .982.663.663 0 0 0 .954 0l6.124-6.304a.71.71 0 0 0 0-.983L11.68.204a.661.661 0 0 0-.955 0 .71.71 0 0 0 0 .982l4.972 5.118-15.022.002A.685.685 0 0 0 0 7c0 .382.302.695.675.695Z"
        fill="#292747"
      />
    </svg>
  );
};
